import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "hero__content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "hero__headline" }, " Eintritt frei! ", -1)
const _hoisted_6 = { class: "hero__text" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Wann?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sonntag, 29. September 2024, "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 10.00 – 17.00 Uhr ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Wo?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Europahalle & Europaplatz, "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-md-none" }),
  /*#__PURE__*/_createTextVNode(" Castrop-Rauxel ")
], -1)
const _hoisted_9 = { class: "d-lg-none karriereheld" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackgroundPattern = _resolveComponent("BackgroundPattern")!
  const _component_HeroBackgroundCommon = _resolveComponent("HeroBackgroundCommon")!
  const _component_SectionSpacerClouds = _resolveComponent("SectionSpacerClouds")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hero", `hero__${_ctx.pageType}`])
  }, [
    _createVNode(_component_BackgroundPattern),
    _createVNode(_component_HeroBackgroundCommon),
    _createElementVNode("div", {
      class: "hero__container",
      style: _normalizeStyle(_ctx.minHeightPx)
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "img_logo",
              src: `${_ctx.themeUri}/assets/img/svg/hero/mobile.svg`,
              alt: "Logo"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "hero__slogan",
              innerHTML: _ctx.sloganSvg
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToKarriereheld && _ctx.scrollToKarriereheld(...args)))
              }, " Zur Jobbörse ")
            ])
          ])
        ])
      ])
    ], 4),
    _createVNode(_component_SectionSpacerClouds, {
      ref: "clouds",
      placement: "top",
      class: "mt-0"
    }, null, 512)
  ], 2))
}